import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';

//Icons
import Success from '@mui/icons-material/CheckCircle';
import Error from '@mui/icons-material/Error';

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    activateCameraSimCardRequest,
    activateCameraSimCardUpdateDevices,
    clearRedux
} from 'Redux/actions'

const ActivateSimCard = (props) => {
    const { single } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { devices, loading, openModal, result } = useSelector(state => state.activateCameraSimCardRedux);

    const closeModal = () => {
        dispatch(clearRedux("ACTIVATE_CAMERA_SIM_CARD"))
    }

    useEffect(() => {
        if (result) {
            let currentDevices = [];
            if (!single) {
                devices.map((item) => {
                    let newItem = result.find((value) => value.esn === item.esn)
                    currentDevices.push({
                        ...item,
                        message: newItem?.message,
                        statusCode: newItem?.status
                    })
                })
                dispatch(activateCameraSimCardUpdateDevices(currentDevices))
                dispatch(clearRedux("ACTIVATE_CAMERA_SIM_CARD", { result: null }))
            } else {
                let messageResult = result?.find((item) => item?.message)
                let currentMessage = messageResult?.message ? messageResult?.message : "";
                dispatch(clearRedux("ACTIVATE_CAMERA_SIM_CARD"))
                if (messageResult?.status === 200) {
                    NotificationManager.success(
                        currentMessage,
                        single ? messages['device_overview_activate_camera_sim_card'] : messages['devices_activate_simcard_title'],
                        3000
                    );
                } else {
                    NotificationManager.error(
                        currentMessage,
                        single ? messages['device_overview_activate_camera_sim_card'] : messages['devices_activate_simcard_title'],
                        3000
                    );
                }
            }
        }
    }, [result])

    let validateMessage = devices?.some((item) => item?.message)

    return (
        <Modal
            open={openModal}
            title={single ? messages['device_overview_activate_camera_sim_card'] : messages['devices_activate_simcard_title']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 40 }}>
                    {
                        !validateMessage &&
                        <p>{single ? messages['devices_activate_simcard_label_single'] : messages['devices_activate_simcard_label']}</p>
                    }
                    {!single &&
                        <>
                            {
                                devices.map((item, index) => {
                                    return (
                                        <CustomCard
                                            key={index}
                                            onClick={() => {
                                                let data = devices;
                                                let selected = data.findIndex((device) => device.id === item.id);
                                                if (selected > -1) data.splice(selected, 1);
                                                dispatch(activateCameraSimCardUpdateDevices(data));
                                                if (data.length === 0) dispatch(clearRedux("ACTIVATE_CAMERA_SIM_CARD"))
                                            }}
                                            hideButton={validateMessage}
                                        >
                                            <div style={{ display: 'grid' }}>
                                                <div>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_activate_simcard_device_name']}</label><span>{item.label}</span>
                                                </div>
                                                <div>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_activate_simcard_serial']}</label><span>{item.esn}</span>
                                                </div>
                                                {
                                                    item?.message &&
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_activate_simcard_response']}</label>
                                                        {
                                                            item?.statusCode === 200
                                                                ? <Success style={{ marginRight: 5, color: '#52C6AD' }} />
                                                                : <Error style={{ marginRight: 5, color: '#c94747' }} />
                                                        }
                                                        <span>{item?.message?.toUpperCase() || ''}</span>
                                                    </div>
                                                }
                                            </div>
                                        </CustomCard>
                                    )
                                })
                            }
                        </>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                {
                    !validateMessage ?
                        <>
                            <Button
                                onClick={() => closeModal()}
                                className="btn-cancel"
                            >
                                {messages['cancel']}
                            </Button>
                            <Button
                                onClick={() => {
                                    dispatch(activateCameraSimCardRequest(devices))
                                }}
                                className="btn-dark-blue"
                            >
                                {messages['devices_activate_simcard_yes']}
                            </Button>
                        </>
                        :
                        <Button
                            onClick={() => closeModal()}
                            className="btn-dark-blue"
                        >
                            {messages['close']}
                        </Button>
                }
            </ModalFooter>
        </Modal>
    )
}

export default ActivateSimCard;